import XLSX from 'xlsx'

import store from '../store'

export const EXCEL_LABELS = {
  variation: {
    status: 'Status',
    referenceNumber: 'Reference number',
    name: 'Title',
    receivedDate: 'Date',
    riskName: 'Risk Name',
    workstream: 'Workstream',
    category: 'Root cause',
    description: 'Description',
    partName: 'Site Name',
    estimatedValue: 'Estimated Value',
    originalValue: 'Original Value',
    agreedValue: 'Agreed Value',
    eotAgreed: 'Actual Impact',
    eotRequested: 'Potential Impact'
  },
  claim: {
    status: 'Status',
    referenceNumber: 'Reference number',
    name: 'Title',
    receivedDate: 'Received date',
    riskName: 'Risk Name',
    workstream: 'Workstream',
    category: 'Root cause',
    description: 'Description',
    partName: 'Site Name',
    estimatedValue: 'Estimated Value',
    originalValue: 'Original Value',
    agreedValue: 'Agreed Value',
    eotAgreed: 'Agreed EOT',
    eotRequested: 'Requested EOT',
    reportingSide: 'Reported by'
  },
  amendment: {
    status: 'Status',
    referenceNumber: 'Reference number',
    name: 'Title',
    receivedDate: 'Received date',
    riskName: 'Risk Name',
    description: 'Description',
    partName: 'Site Name',
    agreedValue: 'Agreed Value'
  },
  early_warning: {
    status: 'Status',
    referenceNumber: 'Reference number',
    name: 'Title',
    receivedDate: 'Received date',
    riskName: 'Risk Name',
    description: 'Description',
    partName: 'Site Name',
    estimatedValue: 'Estimated Value'
  }
}

export const getExcelLabels = (type, area) => {
  const labels = {
    ...store.state.variationsStages[type].reduce((acc, curr) => ({ ...acc, [curr.prefix]: curr.prefix.toUpperCase() }), {}),
    ...EXCEL_LABELS[type]
  }
  if (area.code !== 'ON') {
    delete labels.workstream
  }
  return labels
}

export const EXAMPLE_DATA = {
  variation: [
    'VR1', 'VP1', 'VO1', 'pending', '123-ref',
    'Example', '10/11/2022', 'Rain',
    'WORKSTREAM', 'Site Hunting',
    'Example variation description', null,
    400, 520.5, 350.5, 10, 5
  ],
  claim: [
    'CN1', 'CI1', 'C1', 'pending', '123-ref',
    'Example', '10/11/2022', 'Rain', 'WORKSTREAM',
    'Site Hunting', 'Example claim description', null,
    400, 520.5, 350.5, 10, 5, 'employer'
  ],
  amendment: [
    'AM1', 'draft', '123-ref', 'Example', '10/11/2022',
    'Rain', 'Example amendment description', null, 400
  ],
  early_warning: [
    'EW1', 'draft', '123-ref', 'Example', '10/11/2022',
    'Rain', 'Example amendment description', null, 400
  ]
}

const getFields = (type, area) => {
  let example = EXAMPLE_DATA[type]
  example = area.code === 'ON'
    ? example.map(i => i === 'WORKSTREAM' ? 'Indexation / Inflation' : i)
    : example.filter(i => i !== 'WORKSTREAM')
  return [
    Object.values(getExcelLabels(type, area)),
    example
  ]
}

export const generateVariationTemplate = (type, area) => {
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(getFields(type, area))
  wb.SheetNames.push(type)
  wb.Sheets[type] = ws
  XLSX.writeFile(wb, `${type}Template.xlsx`)
}
